import React from "react";
import { Wrapper, Image, Text } from "./styled";
import Icon from "../../../../../../images/gray/saved.svg";

const SavedIcon = () => {
  return (
    <Wrapper>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default SavedIcon;
